import React, { useState } from "react";
import { bool, func } from "prop-types";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Drawer from "pages/_components/Drawer/Drawer";
import { useEcheckTabs } from "pages/echeck/hooks/useEcheckTabs";
import { echeqOptions } from "util/echecks";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import TitleColumns from "./components/TitleColumns";
import EmitedEcheckItem from "./components/ItemRow";
import EmitedSideBarForm from "./components/SideBarForm";
import FilterTags from "../components/FilterTags";

const EmitedEchecks = ({ isDesktop, fetchMoreTransactions }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { echeqList = [], fetching, hasMoreData, echeqPagination, echeqFilters } = useSelector(
        (state) => state.echecks,
    );
    useEcheckTabs(1);
    // const columns = isDesktop ? 8 : 2;
    const row = isDesktop ? 1 : 3;
    // const colsTemplate = `repeat(${columns}1fr)`;

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    return (
        <div className="container pb-8 echeq-table-wrapper">
            <FilterTags openSideBarFilters={openSideBarFilters} optionEcheq={echeqOptions[1]} />
            {echeqList?.length === 0 && !fetching ? (
                <div className="box info service-payments__no-data">
                    <Image src="images/information_fill.svg" /> <I18n id="echecks.service.noEmited" />
                </div>
            ) : (
                <ProductList
                    fetchingWithPreviousData
                    fetching={fetching}
                    items={echeqList || []}
                    noDataText="global.no.results"
                    noFiltersDataText="global.no.results"
                    renderItem={(item) => (
                        <GridTable.Container
                            rows={row}
                            key={`emited-echeck-item-${item.cheque_numero}`}
                            renderAs={Link}
                            to={`/echecks/emitted/${item.cheque_id}`}
                            className={!isDesktop && "box box-shadow"}>
                            <EmitedEcheckItem emitededEcheck={item} setDrawer={setActionDrawer} isDesktop={isDesktop} />
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <>
                            <GridTable className="echeq-table emited underlined tablelist">
                                {isDesktop && (
                                    <GridTable.Header>
                                        <GridTable.Container rows={row}>
                                            <TitleColumns />
                                        </GridTable.Container>
                                    </GridTable.Header>
                                )}
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                            {hasMoreData && (
                                <Button
                                    bsStyle="link"
                                    onClick={() => fetchMoreTransactions(echeqPagination, echeqFilters)}
                                    image="images/figma/icon/arrow.svg"
                                    label="global.showMore"
                                    className="view-more"
                                />
                            )}
                        </>
                    )}
                </ProductList>
            )}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <EmitedSideBarForm closeSidebar={setOpenSidebar} />
            </Drawer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

EmitedEchecks.propTypes = {
    isDesktop: bool.isRequired,
    fetchMoreTransactions: func.isRequired,
};

export default EmitedEchecks;
